import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import {
  RequestTypes,
  registerItemKeys,
} from '@core/react-query/features/registers/registers/register/items/item'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { registerItemsKeys } from '@core/react-query/features/registers/registers/register/items'
import { IRegisterItemAttachment } from '@core/entities/register/RegisterItemAttachment'

export const useArchiveRegisterItemAttachment = (
  options?: UseMutationOptions<
    IRegisterItemAttachment,
    RequestErrorType,
    RequestTypes['archiveRegisterItemAttachment']
  >,
) => {
  const queryClient = useQueryClient()

  return useMutation({
    ...registerItemKeys.archiveRegisterItemAttachment,
    ...options,
    onSuccess: (data, variables, context) => {
      // Refresh the item list + item detail so the attachment count on the tab
      // badge and item properties update.
      queryClient.invalidateQueries(registerItemsKeys.itemsByRegisterId._def)
      queryClient.invalidateQueries(
        registerItemKeys.byId({
          registerId: variables.registerId,
          registerItemId: variables.registerItemId,
        }),
      )
      options?.onSuccess?.(data, variables, context)
    },
  })
}
